module.exports = __webpack_public_path__ + "static/media/4pic.0bd5c79a.png";